import { createFileRoute } from '@tanstack/react-router';
import { ToolDetailPage } from '@/pages/member-portal/tools/ToolDetailPage';

// Member-facing tool detail. `$id` is the published tool id.
function MemberPortalToolDetailRoute() {
	return <ToolDetailPage />;
}

export const Route = createFileRoute('/_authenticated/_app/member-portal/tools/$id')({
	component: MemberPortalToolDetailRoute,
});
